const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Get the photo URL for a parliamentarian from the local API
 * @param {string} phid - The PHID of the parliamentarian
 * @returns {string} The URL to the parliamentarian's photo
 */
export const getParliamentarianPhotoUrl = (phid) => {
  if (!phid) return null;
  return `${API_URL}/api/photos/${phid}`;
};
